import * as React from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { Container } from './Container';
import { useParams } from 'react-router';
import { ALL_NEWS_QUERY } from '../../../client/__graphql__/queries/getAllNews';

import { SectionArticles } from './SectionArticles';
import {
  NewsType,
  NewsSearchTypes,
} from '../../../client/types/generated/types';

export const ServiceContainerStyle = styled.div`
  width: 100%;
  margin: 0 auto;
  display: grid;
  margin-top: 2em;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  text-align: center;
  margin-bottom: 4em;

  @media all and (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }

  @media all and (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionServices: React.FC<{
  style?: any;
  url?: string;
  limit?: number;
}> = ({ style, url, limit }) => {
  const params = useParams<{ urltag: string }>();

  if (params.urltag) {
    return (
      <SectionArticles
        article_type={'nybygg-tjenester'}
        url={params.urltag}
        style={style}
        small={true}
        subdomain={'tjeneste'}
        limit={limit}
      />
    );
  } else {
    //frontpage
    return (
      <SectionArticles
        searchType={NewsSearchTypes.NYBYGGFRONTPAGE}
        style={style}
        small={true}
        limit={limit}
      />
    );
  }
};
